import { IOfferScopeCrudModalLang } from '../../../types/lang'

export const offerScopeCrudModalLang: IOfferScopeCrudModalLang = {
	offer_scope_crud_modal: {
		title_create: 'Create offer scope_ru',
		title_edit: 'Edit offer scope_ru',
		title_remove_single: 'Remove <span>offer scope_ru</span>',
		title_notes_view: 'View notes for offer scope_ru',
		title_notes_edit: 'Edit notes for offer scope_ru',
		field_name_label: 'Name_ru',
		field_name_placeholder: 'Name_ru',
		field_cap_label: 'Cap_ru',
		field_cap_placeholder: 'Cap_ru',
		field_cap_type_label: 'Cap Type_ru',
		field_cap_type_placeholder: 'Cap Type_ru',
		field_status_label: 'Status_ru',
		field_status_placeholder: 'Status_ru',
		field_notes_label: 'Notes_ru',
		field_notes_placeholder: 'Notes_ru',
		msg_remove_confirm: 'Are you sure?_ru',
		btn_create: 'Create_ru',
		btn_update: 'Save_ru',
		btn_remove: 'Remove_ru',
		btn_close: 'Close_ru'
	}
}